import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { message } from "antd";
import "assets/css/demo.css"
import MyContext from "MyContext";
import {
  useTable,
  usePagination,
  useGlobalFilter,
  useSortBy,
} from "react-table";
import moment from 'moment';
import ProjectDetails from "./Projectdetailsss";
import { useHistory } from "react-router-dom";
import PaginationSection from "./PaginationSection";
import ReactPaginate from 'react-paginate';
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Form
} from "react-bootstrap";



function FreelancerSubsInvoices() {
  const { endPointUrl, Token } = useContext(MyContext);
  const [ID, setID] = useState([]);
  const [allDetails, setallDetails] = useState([]);
  const history = useHistory();
  const [sortOption, setSortOption] = useState("Latest");


  function generateInvoiceNumber(subDate, subId) {
    const date = new Date(subDate);
    const year = date.getFullYear().toString().slice(-2);
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Add 1 to month because it's zero-based
    const invoiceCountStr = '001'; // You can start with '001' and increment it for each invoice
    const invoiceNumber = `INV-${year}-${month}-00${subId}`;
    return invoiceNumber;
  }

  const getongoingprojects = async () => {
    try {
      const { data } = await axios.post(endPointUrl + "/admin/getAllsubscription", {
        Token,
      });

      setallDetails(data.data);
      console.log(data.data);

      // console.log(allDetails);

    } catch {
      console.log("get ongoing projects is not working");
    }
  };
  // const data = React.useMemo(() => Array.isArray(allDetails) ? allDetails : [], [allDetails]);
  const data = React.useMemo(() => Array.isArray(allDetails) ? allDetails : [], [allDetails]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Invoice ID",
        accessor: "", // Access the payment date to generate the invoice number
        Cell: ({ row }) => (
          <span>{generateInvoiceNumber(row.original.Subscription_Date, row.original.Sub_ID)}</span>
        ),
      },
      {
        Header: "Freelancer",
        accessor: "freelancer.Name",
      },
      {
        Header: "Num Of Bids",
        accessor: "NumOfbids",
      },
      {
        Header: "Amount",
        accessor: "Amount",
      },
      {
        Header: "Payment Reference",
        accessor: "Payment_Reference",
      },
      // {
      //   Header: "Subscription Date",
      //   accessor: "Subscription_Date",
      //   Cell: ({ value }) => (
      //     <span>{moment(value).format('DD/MM/YYYY')}</span>
      //   ),
      //   sortType: "datetime", 
      // },
      {
        Header: "Action",
        accessor: "Sub_ID",
        Cell: ({ row }) => (
          <div>
            {/* "Update" icon */}
            <span
              onClick={() => handleclick(row.original.Sub_ID,
                row.original.Subscription_Date)}
              style={{ cursor: "pointer", marginRight: "10px" }}
            >
              <Button style={{ fill: "#07b274" }}>View</Button>
            </span>
          </div>
        ),
      },
    ],
    []
  );
  useEffect(() => {
    getongoingprojects();
  }, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
    gotoPage,
    pageCount,
    state,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 5 },
      autoResetPage: false,
      sortBy: [{ id: "Subscription_Date", desc: sortOption === "Oldest" }],
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const { globalFilter, pageIndex, pageSize } = state;


  const handleclick = (Id, subDate) => {
    const invoiceNumber = generateInvoiceNumber(subDate, Id);
    // const url = `/Invoice-Generator/${Id}/${invoiceNumber}`;
    // alert(Id);
    const url = `/Subscription-Invoice-Generator/?invoiceNumber=${invoiceNumber}&Id=${Id}`;
    window.open(url, '_blank'); // Open the URL in a new tab
  };

  const handleSortChange = (event) => {
    setSortOption(event.target.value);
  };

  return (
    <>

      <Container fluid>
        <Row>
          <Col lg="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">
                  <Form className="d-flex">
                    <Col lg="10">
                      <Form.Control
                        type="search"
                        placeholder="Search"
                        //   className="mx-2"
                        aria-label="Search"
                        value={globalFilter || ''} onChange={(e) => setGlobalFilter(e.target.value)}
                      />
                    </Col>
                    <Col lg="2">
                      <Form.Control
                        as="select"
                        value={sortOption}
                        onChange={handleSortChange}
                      //   className="mx-2"
                      >
                        <option value="Latest">Latest</option>
                        <option value="Oldest">Oldest</option>
                      </Form.Control>
                    </Col>
                  </Form>

                </Card.Title>
              </Card.Header>
              <Card.Body className="table-full-width table-responsive px-0">
                <Table className="table-hover table-striped " {...getTableProps()}>
                  <thead>
                    {headerGroups.map((headerGroup) => (
                      <tr {...headerGroup.getHeaderGroupProps()}>
                        {headerGroup.headers.map((column) => (
                          <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                            {column.render("Header")}
                            {/* Add a sort direction indicator */}
                            <span>
                              {column.isSorted
                                ? column.isSortedDesc
                                  ? " 🔽"
                                  : " 🔼"
                                : ""}
                            </span>
                          </th>
                        ))}
                      </tr>
                    ))}
                  </thead>
                  <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                      prepareRow(row);
                      return (
                        <tr  {...row.getRowProps()}>
                          {/* {console.log(row.original.id)} */}
                          {row.cells.map((cell) => {
                            //  const { column } = cell.value;
                            //  let Id = column.Name;
                            //  console.log(cell.value);

                            return (<td  {...cell.getCellProps()}> {cell.render("Cell")}</td>)

                          })}
                        </tr>
                      );
                    }

                    )}
                  </tbody>
                </Table>
              </Card.Body>
              <PaginationSection
                pageIndex={pageIndex}
                pageCount={pageOptions.length}
                canPreviousPage={canPreviousPage}
                canNextPage={canNextPage}
                gotoPage={gotoPage}
                previousPage={previousPage}
                nextPage={nextPage}
                pageSize={pageSize}
                setPageSize={setPageSize}
                pageOptions={pageOptions}
              />

            </Card>

          </Col>
        </Row>
      </Container>



    </>
  );
}

export default FreelancerSubsInvoices;